import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { fetchXhr } from '../../fetchXhr.js';
import { buildCommonFetchOptions } from './buildCommonFetchOptions.js';

var csvUploader = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(files, url, _, onProgress) {
    var _document;

    var formData, fetchOptions, response, json;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(files.length <= 0)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            formData = new FormData();
            formData.append('csv', files[0]);
            fetchOptions = buildCommonFetchOptions(formData, onProgress);
            fetchOptions.headers = {
              'X-CSRF-Token': (_document = document) === null || _document === void 0 || (_document = _document.querySelector('meta[name=csrf-token]')) === null || _document === void 0 ? void 0 : _document.content
            };
            fetchOptions.credentials = 'same-origin';
            _context.next = 9;
            return fetchXhr(url, fetchOptions);

          case 9:
            response = _context.sent;
            _context.next = 12;
            return response.json();

          case 12:
            json = _context.sent;

            if (!(response.status >= 400)) {
              _context.next = 15;
              break;
            }

            throw json;

          case 15:
            return _context.abrupt("return", json);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function csvUploader(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var externalCSVUploader = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(files, url, _, onProgress, authToken) {
    var formData, fetchOptions, response, json;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(files.length <= 0)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", null);

          case 2:
            formData = new FormData();
            formData.append('csv', files[0]);
            fetchOptions = buildCommonFetchOptions(formData, onProgress);
            fetchOptions.headers = {
              Authorization: "Bearer ".concat(authToken)
            };
            fetchOptions.credentials = 'same-origin';
            _context2.next = 9;
            return fetchXhr(url, fetchOptions);

          case 9:
            response = _context2.sent;
            _context2.next = 12;
            return response.json();

          case 12:
            json = _context2.sent;

            if (!(response.status >= 400)) {
              _context2.next = 15;
              break;
            }

            throw json;

          case 15:
            return _context2.abrupt("return", json);

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function externalCSVUploader(_x5, _x6, _x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();

export { csvUploader, externalCSVUploader };